import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ErrorDeApi } from '@nucleo/api/cliente'
import { useTrabajoSinGuardar } from '@nucleo/trabajoSinGuardar'
import { ETAPAS_DE_LA_MATRIZ } from './etapas'
import { crearMatriz } from './clienteDeMatrices'
import { ALCANCE_VACIO, FormularioDeAlcance } from './FormularioDeAlcance'
import type { AlcanceEntrada } from './tipos'

export function NuevaMatriz() {
  const navegar = useNavigate()
  const [trabajando, setTrabajando] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [modificado, setModificado] = useState(false)
  useTrabajoSinGuardar(modificado, 'El alcance de la nueva matriz')

  const enviar = async (alcance: AlcanceEntrada) => {
    setTrabajando(true)
    setError(null)
    try {
      const m = await crearMatriz(limpiar(alcance))
      setModificado(false)
      navegar(`/matrices/${m.id}/levantamiento`)
    } catch (e) {
      setError(e instanceof ErrorDeApi ? e.message : 'No fue posible crear la matriz. Tus datos siguen en el formulario: vuelve a intentarlo.')
    } finally {
      setTrabajando(false)
    }
  }

  return (
    <section className="grid gap-4" aria-labelledby="titulo-nueva">
      <nav aria-label="Migas" className="text-pequeno text-texto-secundario">
        <Link to="/" className="text-accion underline-offset-2 hover:underline">Matrices</Link> <span aria-hidden="true">/</span> Nueva matriz
      </nav>
      <header className="sst-tarjeta sst-caso-cabecera">
        <p className="cs-eyebrow">Nueva matriz · Etapa 1 de 4</p>
        <h1 id="titulo-nueva">Define el alcance de la matriz</h1>
        <p className="text-texto-secundario">MIPER basada en la guía ISP. Al continuar, Atalaya te pedirá describir el proceso para proponer las tareas.</p>
        <ol className="sst-etapas" data-orientacion="horizontal" aria-label="Etapas de la matriz">
          {ETAPAS_DE_LA_MATRIZ.map((etapa, i) => (
            <li key={etapa.ruta} className="sst-etapa" aria-current={i === 0 ? 'step' : undefined} style={{ cursor: 'default' }}>
              <span className="sst-etapa-numero" aria-hidden="true">{etapa.numero}</span>
              <span className="sst-etapa-textos"><span>{etapa.titulo}</span><small>{etapa.detalle}</small></span>
            </li>
          ))}
        </ol>
      </header>
      <FormularioDeAlcance inicial={ALCANCE_VACIO} textoDeEnvio="Crear matriz y continuar al levantamiento" trabajando={trabajando} error={error} alModificar={setModificado} alEnviar={(a) => void enviar(a)} />
    </section>
  )
}

export function limpiar(a: AlcanceEntrada): AlcanceEntrada {
  const o = (v: string | null | undefined) => (v && v.trim() ? v.trim() : null)
  return {
    empresa: { razon_social: a.empresa.razon_social.trim(), rut: o(a.empresa.rut), direccion: o(a.empresa.direccion), comuna: o(a.empresa.comuna) },
    centro: { nombre: a.centro.nombre.trim(), tipo: a.centro.tipo, direccion: o(a.centro.direccion), comuna: o(a.centro.comuna) },
    alcance: a.alcance.trim(),
    responsable: { nombre: a.responsable.nombre.trim(), email: o(a.responsable.email) },
    participantes: a.participantes,
  }
}
